import type { FC } from 'react';
import { z } from 'zod';

import { GetOneDevice } from '@/api/fe-api/view/queries/get-one-device';
import { FullPageContent } from '@/components/layout/full-page-content';
import { Dashboard } from '@/components/looker/dashboard';
import { PageActions } from '@/components/pages/assets/details/page-actions';
import { PageActionBenchmark } from '@/components/pages/assets/details/page-actions/page-action-benchmark';
import { PageActionDataExplorer } from '@/components/pages/assets/details/page-actions/page-action-data-explorer';
import { codec, useQueryParams } from '@/hooks/router/use-query-params';
import { useCurrentAsset } from '@/hooks/use-current-asset';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { useMe } from '@/hooks/use-me';

export const DetailsPage: FC = () => {
  const { asset, vehicle } = useCurrentAsset();
  const me = useMe();
  const featureFlag = useFeatureFlag();
  const actionsFeatureFlags = [
    featureFlag('dataExplorer'),
    featureFlag('newDataExplorer'),
    featureFlag('assets'),
  ];
  const [filters] = useQueryParams({
    device: {
      key: 'device',
      schema: z.string().optional().default(''),
      codec: codec.string,
    },
    system_id: {
      key: 'system_id',
      schema: z.string().optional().default(''),
      codec: codec.string,
    },
    array_id: {
      key: 'array_id',
      schema: z.string().optional().default(''),
      codec: codec.string,
    },
    node_id: {
      key: 'node_id',
      schema: z.string().optional().default(''),
      codec: codec.string,
    },
    container_id: {
      key: 'container_id',
      schema: z.string().optional().default(''),
      codec: codec.string,
    },
    bank_id: {
      key: 'bank_id',
      schema: z.string().optional().default(''),
      codec: codec.string,
    },
    pack_id: {
      key: 'pack_id',
      schema: z.string().optional().default(''),
      codec: codec.string,
    },
    module_id: {
      key: 'module_id',
      schema: z.string().optional().default(''),
      codec: codec.string,
    },
  });

  const device = GetOneDevice.useQuery({ id: filters.device }).data;

  const dashboardFilters = {
    ...filters,
    system_id:
      filters.system_id || asset?.fullFrontendId || vehicle?.fullFrontendId,
  };

  return (
    <FullPageContent testId="recommendation-details-page">
      <Dashboard key={asset?.id} id="details" filters={dashboardFilters} />
      {device &&
      asset &&
      me.config.type !== 'mobility' &&
      actionsFeatureFlags.some((flag) => flag) ? (
        <PageActions>
          <PageActionBenchmark device={device} />
          {featureFlag('detailsToDexLink') ? (
            <PageActionDataExplorer device={device} />
          ) : null}
        </PageActions>
      ) : null}
    </FullPageContent>
  );
};
